import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[nbxUppercase]',
  standalone: true,
  host: { '(input)': 'onInput($event)' },
})
export class UppercaseDirective {
  private readonly _el = inject(ElementRef<HTMLInputElement>);

  /**
   * Uppercases the input in place and re-dispatches a native `input` event so the bound control
   * picks up the transformed value. Works for reactive forms, Signal Forms `[formField]` and plain
   * `ngModel` alike (Signal Forms' fake NgControl has no writable `.control`, so we never touch it).
   */
  onInput(event: Event): void {
    const input = (event.target as HTMLInputElement) ?? this._el.nativeElement;
    const upper = input.value.toUpperCase();
    if (upper === input.value) {
      return;
    }

    const start = input.selectionStart;
    const end = input.selectionEnd;

    input.value = upper;
    // Notify the bound control (native input handler / CVA) of the uppercased value. Re-entry is
    // safe: the next onInput sees upper === value and returns early.
    input.dispatchEvent(new Event('input', { bubbles: true }));

    if (start !== null && end !== null) {
      input.setSelectionRange(start, end);
    }
  }
}
